export type ScheduleSearchMode = 'procedure' | 'specialist' | 'clinic';

export interface ScheduleSearchSuggestion {
  label: string;
  category: string;
  mode: ScheduleSearchMode;
}

export interface ScheduleSearchSuggestionGroup {
  category: string;
  suggestions: ScheduleSearchSuggestion[];
}

export function normalizeScheduleSearch(value: string | null | undefined): string {
  return (value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase('pt-BR')
    .trim();
}

export function friendlyProcedureName(value: string | null | undefined): string {
  const name = (value ?? '').trim();

  if (/^consulta em consult[oó]rio\b/i.test(name)) {
    return 'Consulta em Consultório';
  }

  return name;
}

export function addScheduleSearchSuggestion(
  suggestions: ScheduleSearchSuggestion[],
  suggestion: ScheduleSearchSuggestion,
  searchTerm: string
): void {
  const normalizedLabel = normalizeScheduleSearch(suggestion.label);
  const normalizedTerm = normalizeScheduleSearch(searchTerm);

  if (
    normalizedLabel.includes(normalizedTerm) &&
    !suggestions.some(
      (item) => item.mode === suggestion.mode && normalizeScheduleSearch(item.label) === normalizedLabel
    )
  ) {
    suggestions.push(suggestion);
  }
}

export function groupScheduleSearchSuggestions(
  suggestions: ScheduleSearchSuggestion[]
): ScheduleSearchSuggestionGroup[] {
  const groups = new Map<string, ScheduleSearchSuggestion[]>();

  suggestions.forEach((suggestion) => {
    const items = groups.get(suggestion.category) ?? [];
    if (items.length < 5) {
      items.push(suggestion);
      groups.set(suggestion.category, items);
    }
  });

  return Array.from(groups, ([category, items]) => ({ category, suggestions: items }));
}
